import { useState, createContext } from 'react'

export const DContext = createContext()

const DataContext = ({ children }) => {

    const [popup, setPopup] = useState({
        visible: false,
        message: '',
        type: 'alert',  // 'alert' | 'confirm'
        resolve: () => { },
    });

    const showAlert = (message) =>
        new Promise((resolve) => {
            setPopup({
                visible: true,
                message,
                type: 'alert',
                resolve,
            });
        });

    const showConfirm = (message) =>
        new Promise((resolve) => {
            setPopup({
                visible: true,
                message,
                type: 'confirm',
                resolve,
            });
        });

    const showDeleteConfirm = (message) =>
        new Promise((resolve) => {
            setPopup({
                visible: true,
                message,
                type: "delete",
                resolve,
            });
        });


    const handlePopupConfirm = () => {
        popup.resolve(true);
        setPopup((prev) => ({ ...prev, visible: false }));
    };

    const handlePopupCancel = () => {
        popup.resolve(false);
        setPopup((prev) => ({ ...prev, visible: false }));
    };

    const data = { showAlert, showConfirm, showDeleteConfirm, popup, handlePopupConfirm, handlePopupCancel }

    return (
        <DContext.Provider value={data}>
            {children}
        </DContext.Provider>
    )
}

export default DataContext